<template>
    <ValidationObserver ref="validationObserver" slim>
        <div>
            <ErrorLogShower />
            <Progressbar processType="BnT" :currentStepIndex="1" @clickstep1="back" />

            <div class="contentblock">
                <section class="contentblock__content">

                    <div class="shop__fieldgroup shop__fieldgroup--no-separator shop__fieldgroup--no-padding-bottom">
                        <component :is="AddressEditorComponent" :enableCumulus="false" />
                    </div>

                    <div class="migrol-form__buttons">
                        <button class="migrol-form__button" @click="back">{{Strings['Shop.ButtonBack']}}</button>
                        <button class="migrol-form__button migrol-form__button--green" @click="forward">{{Strings['Shop.ButtonContinue']}}</button>
                    </div>

                </section>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import TransactionAddressesOneUP from '../_common/TransactionAddressesOneUP'
    import TransactionAddressesManyUP from '../_common/TransactionAddressesManyUP'
    import Progressbar from '../_common/Progressbar'
    import { ValidationObserver } from 'VeeValidate'
    import ErrorLogShower from '../_common/ErrorLogShower'
    import { stepBeforeRouteLeave } from '@/utils/utils'

    import Transaction from '@/models/Transaction'
    import { mapState } from 'vuex'

    export default {
        props: {
            stepMode: {
                type: String,
                required: true
            }
        },
        computed: {
            ...mapState([
                'Strings'
            ]),
            CurrentTransaction() {
                return Transaction.query().with(['positions.warenempfaenger', 'material', 'deliveryPeriod']).first();
            },
            AddressEditorComponent() {
                return this.CurrentTransaction.positions.length > 1 ? 'TransactionAddressesManyUP' : 'TransactionAddressesOneUP';
            },
            AllowedNavigationPaths() {
                let paths = [];
                //allow back to step 1
                paths.push({ path: '/', requiresValidation: false });
                //forward to review step
                paths.push({ path: '/' + this.stepMode + '-review', requiresValidation: true });

                return paths;
            }
        },
        data() {
            return {
                validationEnabled: false
            }
        },
        methods: {
            back() {
                this.$router.push('/').catch(() => { });
            },
            forward() {
                this.$router.push('/' + this.stepMode + '-review').catch(() => { });
            }
        },
        mounted() {
            if (window.dataLayer) {

                let step1optionValue = this.CurrentTransaction.deliveryPeriod.displayText;
                if (this.CurrentTransaction.myClimate == true) {
                    step1optionValue += ' | myclimate';
                }

                window.dataLayer.push({
                    'event': 'checkoutOption',
                    'ecommerce': {
                        'checkout_option': {
                            'actionField': { 'step': 1, 'option': step1optionValue }
                        }
                    }
                });

                window.dataLayer.push({
                    event: 'begin_checkout',
                    shipping_tier: this.CurrentTransaction.deliveryPeriod.displayText,
                    quantity: this.CurrentTransaction.totalAmount,
                    zip: this.CurrentTransaction.positions[0].warenempfaenger.zipcode.toString(),
                    ecommerce: {
                        items: [{
                            item_name: 'Diesel', // Produktname in Shopsprache - Heiz�l, Holzpellets, Diesel
                            item_id: this.CurrentTransaction.material.materialNumber, // �bergeordnete ID f�r Heiz�l, Holzpellets, Diesel da Variante des Produktes noch nicht vorhanden - wenn nicht vorhanden leer
                            price: this.CurrentTransaction.material.getUnitPrice(null) ? parseFloat((this.CurrentTransaction.material.getUnitPrice(null) / 100).toFixed(4)) : null, // Preis per Liter
                            item_brand: 'migrol', // Brand des Produktes - falls nicht vorhanden 'migrol'
                            item_category: 'diesel', // z.B.: Heiz�l, Holzpellets, Diesel
                            item_variant: this.CurrentTransaction.material.name, // Produktvariant, wenn vorhanden (zB.: gelb) Varaint der Produkte erst im Checkout Steps ausw�hlbar - Bitte leer lassen
                            quantity: this.CurrentTransaction.totalAmount // Menge
                        }]
                    }
                });
            }
        },
        beforeRouteLeave(to, from, next) {
            stepBeforeRouteLeave(this.AllowedNavigationPaths, this.$refs.validationObserver, to, next);
        },
        components: {
            TransactionAddressesOneUP,
            TransactionAddressesManyUP,
            ValidationObserver,
            Progressbar,
            ErrorLogShower
        }
    };
</script>